module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm2_m_jp.498e66d721c8f836dcaf0794384d7d92.png";